import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../cart";

const Navbar = () => {
  const { count, setOpen } = useCart();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const left = [
    { id: "top", label: "Acasă" },
    { id: "products", label: "Shop" },
  ];
  const right = [
    { id: "story", label: "Poveste" },
    { id: "contact", label: "Contact" },
  ];

  const scrollTo = (id) => {
    setMobileOpen(false);
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#FAF5EC]/85 backdrop-blur-xl border-b border-[#E5DDD0]" : "bg-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20 flex items-center justify-between h-20">
        {/* Left links */}
        <nav className="hidden md:flex items-center gap-10">
          {left.map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="text-sm tracking-wide text-[#1A1612] hover:text-[#B8954C] transition-colors duration-300"
              data-testid={`nav-link-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        {/* Center logo */}
        <Link
          to="/"
          className="font-serif text-2xl md:text-3xl tracking-[0.35em] text-[#1A1612]"
          data-testid="logo-home"
        >
          ELENUIT
        </Link>

        {/* Right links + cart */}
        <div className="flex items-center gap-6 md:gap-10">
          <nav className="hidden md:flex items-center gap-10">
            {right.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollTo(l.id)}
                className="text-sm tracking-wide text-[#1A1612] hover:text-[#B8954C] transition-colors duration-300"
                data-testid={`nav-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
          </nav>
          <button
            onClick={() => setOpen(true)}
            className="relative text-[#1A1612] hover:text-[#B8954C] transition-colors duration-300"
            data-testid="cart-open-button"
            aria-label="Coș"
          >
            <ShoppingBag size={22} strokeWidth={1.4} />
            <span
              className="absolute -top-2 -right-2 bg-[#1A1612] text-[#FAF5EC] text-[10px] w-5 h-5 rounded-full flex items-center justify-center font-medium"
              data-testid="cart-count-badge"
            >
              {count}
            </span>
          </button>
          <button
            className="md:hidden text-[#1A1612]"
            onClick={() => setMobileOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#FAF5EC]/95 backdrop-blur-xl border-t border-[#E5DDD0] px-6 py-8 space-y-6">
          {[...left, ...right].map((l) => (
            <button
              key={l.id}
              onClick={() => scrollTo(l.id)}
              className="block text-base tracking-wide text-[#1A1612] hover:text-[#B8954C] transition"
              data-testid={`mobile-nav-${l.id}`}
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Navbar;
